import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { formatMoney } from '../../shared/format';
import CurrencySwitch from '../../shared/currency-switch';
import { getCurrencyIcon } from '../../../../shared/js/get-currency-icon';

import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';

import InputField from '../../shared/form-elements/input';
import SelectField from '../../shared/form-elements/select';

lessRequire('modules/finances/components/payments-form.less');

const propTypes = {
	handleSubmit: PropTypes.func,
	orderPayout: PropTypes.func,
	initialValues: PropTypes.object,
	intl: PropTypes.func,
	headerCurrency: PropTypes.string
};

const Form = ({
	isCurrencyExchangeEnabled,
	initialValues,
	handleSubmit,
	orderPayout,
	paymentsFormData,
	exchangeData,
	exchangeCurrencies,
	data,
	currencyBalances,
	toggleExchangeCurrencySwitch,
	intl,
	headerCurrency
}) => {
	const { minAmount, allowFloats, payout_percent, payout_fee } = initialValues;
	const isExchangeRateDisplayed = exchangeData && initialValues.currency !== exchangeData.exchange_currency;
	const {selling_rate, buying_rate } = exchangeData.exchangeRates;
	const exchange_rate = exchangeData.exchange_currency === 'usd' ? selling_rate: buying_rate;
	const exchange_coefficient = exchangeData.exchange_currency === 'usd' ?
		1/(exchange_rate || 0): (exchange_rate || 0);
	const exchangeMoney = (paymentsFormData.amount || '0').split(' ').join('') * exchange_coefficient;
	const notGreaterThenBalance = value => value &&
	(toNumber(value) > toNumber(initialValues.amount)) ?
		`${intl('Не должно превышать')} ${initialValues.amount}`: undefined;
	const psCurrency = getCurrencyIcon(exchangeData.exchange_currency || initialValues.currency);

	const listOfExchangeCurrencies = exchangeCurrencies.filter(it => headerCurrency !== 'rub' || it.id === 'rub');

	return (
		<form action="#" className="payments-form clearfix" onSubmit={
			handleSubmit(formData => orderPayout(formData, exchangeMoney))
		}>
			<div className="payments-form__position-element">
				<table>
					<tbody>
						<tr>
							<td className="label">
								<div className="payments-form__position-name">
									<h2 className="font-proxima-nova-bold">{intl('Выплаты')}</h2>
								</div>
							</td>
							<td className="payout-info">
								<div className="finances-wrap-position__currency">
									{
										isCurrencyExchangeEnabled &&
										initialValues.currency !== 'rub' &&
										<CurrencySwitch
											listOfCurrencies={listOfExchangeCurrencies}
											activeCurrency={
												exchangeData.exchange_currency ||
												initialValues.currency
											}
											onSwitch={
												exchange_rate ?
													toggleExchangeCurrencySwitch:
													() => {}
											}
											buttonsType="button"
										/>
									}
								</div>
							</td>
							<td className="amount">
								<div className="element__field">
									<Field name="amount"
										component={InputField}
										placeholder={''}
										format={val => {
											updateCurrencyIconPosition(val);
											return val;
										}}
										normalize={value => formatMoney(value, allowFloats)}
										shouldDisable={isEmpty(initialValues.paymentMethodOptions)}
										validate={[notGreaterThenBalance]}
										warn={[notGreaterThenBalance]}
									/>
									<div id="currencyInputIcon" >{getCurrencyIcon(initialValues.currency)}</div>
									{isExchangeRateDisplayed && exchange_rate &&
										<div className="exchange-rate-value" >
											{Math.round(exchangeMoney * 100) / 100} {
												getCurrencyIcon(exchangeData.exchange_currency)
											}
										</div>
									}
								</div>
								<span className="payout-exchange-rate">
									<span>{intl('Минимальная сумма')}
										{' '}
										{`${formatMoney(parseFloat(minAmount), true)}
											${getCurrencyIcon(data.exchange_currency)}`}
									</span>
									{isExchangeRateDisplayed &&
										<span>
											{exchange_rate ?
												'' :
												intl('Курс еще не установлен')
											}
										</span>
									}
								</span>
							</td>
							<td className="payment">
								<div className="element__payout-methods">
									<Field
										name="payment"
										component={SelectField}
										options={preparePaymentsOptions(initialValues.paymentMethodOptions)} />
									{
										!Number(payout_fee) &&
										<span className="payout-system-percent">
											{Number(payout_percent) > 0 ?
												<div className="payout-system-percent-content">
													{intl('Бонус') + ' ' + `+${Number(payout_percent)}%`}
													<div className="payout-system-percent-explanation">
														{intl('мы покрываем комиссию')} {`${Number(payout_percent)}%`}
													</div>
												</div> :
												<span>{intl('Комиссия') + ' ' + `${Number(payout_percent)}`}{'%'}</span>
											}
										</span>
									}
									{
										!!Number(payout_fee) &&
										<div className="payout-system-percent">
											{ Number(payout_fee) > 0
												? <div className="payout-system-percent-content">
													{`${intl('Бонус')} ${Number(payout_fee)} ${psCurrency}`}
													<div className="payout-system-percent-explanation">
														{intl('мы покрываем комиссию')} {`${Number(payout_fee)} ${psCurrency}`}
													</div>
												</div>
												: <span>{`${intl('Комиссия')} ${Number(payout_fee)} ${psCurrency}`}</span>
											}
										</div>
									}
								</div>
							</td>
							<td className="action">
								<div className="payments-form__position-button">
									<button
										className="button yellow-btn font-proxima-nova-semibold"
										disabled={isEmpty(initialValues.paymentMethodOptions)}
									>{intl('Заказать выплату')}</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<span id="hiddenValue" />
		</form>
	);
};

function updateCurrencyIconPosition (val) {
	let hiddenValue = document.querySelector('#hiddenValue');
	if (hiddenValue) {
		hiddenValue.innerHTML = val;
		const style = window.getComputedStyle(hiddenValue);
		let width = Number(style['width'].replace('px', ''));
		let el = document.getElementById('currencyInputIcon');
		el.style['left'] = 10 + width + 'px';
	}
}

function preparePaymentsOptions(options) {
	return options.map(entity => ({
		...entity,
		label: (
			<div className="payment-options">
				<img className="payment-options__image" src={entity.image || '//placehold.it/30x30'} alt={entity.label} />
				<div className="payment-options__label">
					<div>
						{entity.label} {entity.purse}
					</div>
					<div>
						{getMainCredential(entity.credentials)}
					</div>
				</div>
			</div>
		)
	}));
}

function toNumber(numberString) {
	if (!numberString || numberString.length < 1) {
		return 0;
	}
	return parseFloat(numberString.replace(/ /g, ''));
}

function getMainCredential(credentials) {
	const keys = Object.keys(credentials);

	if (keys.length === 1) {
		return credentials[keys[0]];
	}

	if (keys.includes('name')) {
		return getMainCredential(omit(credentials, 'name'));
	}

	return credentials.card || credentials.account || credentials.phone || credentials[keys[0]];
}

Form.propTypes = propTypes;
export default reduxForm({
	form: 'paymentsForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/payments-form.js